module.exports = "/static/assets/f0c50733c9b6b3e548afc6914a0c7200.png";